module.exports = __webpack_public_path__ + "static/media/menu-white.404e40ca.svg";